var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Functions.define_ol_event_class = function () {
    OCS.Viewer.Classes.OlEvent = new Class({
        Implements: [new Class(OCS.Viewer.Interfaces.OlObject), new Class(OCS.Viewer.Interfaces.OlEvent)]
    });
};
OCS.Viewer.Functions.define_ol_event_class();
